// extracted by mini-css-extract-plugin
module.exports = {"content-container":"_1sAMf","items-container":"qnZmk","wrapper":"_1ReaR","image":"_1xe89","items-wrapper":"_2sMXk","content-wrapper":"_2U3Li","summary":"VG2Ly"};